import { useEffect, useMemo, useRef, useState } from 'react'
import * as ChecklistHttp from '../../../../services/api/https/checklist-operacional/checklist.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_GET: 'Adquirindo informações dos checklists',
}

const INITIAL_STATE = {
  checklists: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
}

export default function useCadastroChecklist() {
  const [state, setState] = useState({ ...INITIAL_STATE })
  const montado = useRef(true)

  useEffect(() => {
    return () => {
      montado.current = false
    }
  }, [])

  const localDispatch = useMemo(() => {
    return {
      async getChecklists(tp_id) {
        try {
          const checklists = await ChecklistHttp.getChecklists(tp_id)
          if (!montado.current) return

          setState(prev => ({
            ...prev,
            checklists,
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        } catch (err) {
          if (!montado.current) return

          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
        }
      },
      resetState() {
        setState({ ...INITIAL_STATE })
      },
      onInit(selectedTp) {
        setState(prev => ({
          ...prev,
          checklists: [],
          selectedTp: selectedTp,
          loadingMessage: selectedTp ? LOAD_MESSAGE.INITIAL_GET : LOAD_MESSAGE.NONE,
          errorMessage: selectedTp ? null : 'Selecione um Operador Logístico',
        }))
      },
      onGlobalFilterChange(value) {
        setState(prev => ({ ...prev, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
